import { HL7_CODE_SYSTEMS, CUSTOM_CODE_SYSTEMS } from './fhir-systems';

export type ReferenceDataItem = {
  code: string;
  display: string;
  system?: string;
};

export const GENDERS: ReferenceDataItem[] = [
  { code: 'male', display: 'Male', system: HL7_CODE_SYSTEMS.ADMINISTRATIVE_GENDER },
  { code: 'female', display: 'Female', system: HL7_CODE_SYSTEMS.ADMINISTRATIVE_GENDER },
  { code: 'other', display: 'Other', system: HL7_CODE_SYSTEMS.ADMINISTRATIVE_GENDER },
  { code: 'unknown', display: 'Unknown', system: HL7_CODE_SYSTEMS.ADMINISTRATIVE_GENDER },
];

export const MARITAL_STATUSES: ReferenceDataItem[] = [
  { code: 'S', display: 'Never Married', system: HL7_CODE_SYSTEMS.MARITAL_STATUS },
  { code: 'M', display: 'Married', system: HL7_CODE_SYSTEMS.MARITAL_STATUS },
  { code: 'D', display: 'Divorced', system: HL7_CODE_SYSTEMS.MARITAL_STATUS },
  { code: 'W', display: 'Widowed', system: HL7_CODE_SYSTEMS.MARITAL_STATUS },
  { code: 'L', display: 'Legally Separated', system: HL7_CODE_SYSTEMS.MARITAL_STATUS },
  { code: 'T', display: 'Domestic Partner', system: HL7_CODE_SYSTEMS.MARITAL_STATUS },
  { code: 'A', display: 'Annulled', system: HL7_CODE_SYSTEMS.MARITAL_STATUS },
  { code: 'UNK', display: 'Unknown', system: HL7_CODE_SYSTEMS.MARITAL_STATUS },
];

export const LANGUAGES: ReferenceDataItem[] = [
  { code: 'en', display: 'English', system: CUSTOM_CODE_SYSTEMS.LANGUAGES },
  { code: 'es', display: 'Spanish', system: CUSTOM_CODE_SYSTEMS.LANGUAGES },
  { code: 'zh', display: 'Chinese', system: CUSTOM_CODE_SYSTEMS.LANGUAGES },
  { code: 'vi', display: 'Vietnamese', system: CUSTOM_CODE_SYSTEMS.LANGUAGES },
  { code: 'tl', display: 'Tagalog', system: CUSTOM_CODE_SYSTEMS.LANGUAGES },
  { code: 'fr', display: 'French', system: CUSTOM_CODE_SYSTEMS.LANGUAGES },
  { code: 'ko', display: 'Korean', system: CUSTOM_CODE_SYSTEMS.LANGUAGES },
  { code: 'ar', display: 'Arabic', system: CUSTOM_CODE_SYSTEMS.LANGUAGES },
  { code: 'ru', display: 'Russian', system: CUSTOM_CODE_SYSTEMS.LANGUAGES },
  { code: 'pt', display: 'Portuguese', system: CUSTOM_CODE_SYSTEMS.LANGUAGES },
  { code: 'hi', display: 'Hindi', system: CUSTOM_CODE_SYSTEMS.LANGUAGES },
  { code: 'pl', display: 'Polish', system: CUSTOM_CODE_SYSTEMS.LANGUAGES },
  { code: 'ja', display: 'Japanese', system: CUSTOM_CODE_SYSTEMS.LANGUAGES },
  { code: 'de', display: 'German', system: CUSTOM_CODE_SYSTEMS.LANGUAGES },
  { code: 'it', display: 'Italian', system: CUSTOM_CODE_SYSTEMS.LANGUAGES },
];

export const ETHNICITIES: ReferenceDataItem[] = [
  { code: '2135-2', display: 'Hispanic or Latino', system: 'urn:oid:2.16.840.1.113883.6.238' },
  {
    code: '2186-5',
    display: 'Not Hispanic or Latino',
    system: 'urn:oid:2.16.840.1.113883.6.238',
  },
];

export const RACES: ReferenceDataItem[] = [
  {
    code: '1002-5',
    display: 'American Indian or Alaska Native',
    system: 'urn:oid:2.16.840.1.113883.6.238',
  },
  { code: '2028-9', display: 'Asian', system: 'urn:oid:2.16.840.1.113883.6.238' },
  {
    code: '2054-5',
    display: 'Black or African American',
    system: 'urn:oid:2.16.840.1.113883.6.238',
  },
  {
    code: '2076-8',
    display: 'Native Hawaiian or Other Pacific Islander',
    system: 'urn:oid:2.16.840.1.113883.6.238',
  },
  { code: '2106-3', display: 'White', system: 'urn:oid:2.16.840.1.113883.6.238' },
  { code: '2131-1', display: 'Other Race', system: 'urn:oid:2.16.840.1.113883.6.238' },
];

export const RELIGIONS: ReferenceDataItem[] = [
  { code: 'christian', display: 'Christian', system: CUSTOM_CODE_SYSTEMS.RELIGIONS },
  { code: 'catholic', display: 'Catholic', system: CUSTOM_CODE_SYSTEMS.RELIGIONS },
  { code: 'protestant', display: 'Protestant', system: CUSTOM_CODE_SYSTEMS.RELIGIONS },
  { code: 'jewish', display: 'Jewish', system: CUSTOM_CODE_SYSTEMS.RELIGIONS },
  { code: 'muslim', display: 'Muslim', system: CUSTOM_CODE_SYSTEMS.RELIGIONS },
  { code: 'hindu', display: 'Hindu', system: CUSTOM_CODE_SYSTEMS.RELIGIONS },
  { code: 'buddhist', display: 'Buddhist', system: CUSTOM_CODE_SYSTEMS.RELIGIONS },
  { code: 'sikh', display: 'Sikh', system: CUSTOM_CODE_SYSTEMS.RELIGIONS },
  { code: 'orthodox', display: 'Orthodox', system: CUSTOM_CODE_SYSTEMS.RELIGIONS },
  { code: 'mormon', display: 'Mormon', system: CUSTOM_CODE_SYSTEMS.RELIGIONS },
  { code: 'jehovah-witness', display: "Jehovah's Witness", system: CUSTOM_CODE_SYSTEMS.RELIGIONS },
  { code: 'atheist', display: 'Atheist', system: CUSTOM_CODE_SYSTEMS.RELIGIONS },
  { code: 'agnostic', display: 'Agnostic', system: CUSTOM_CODE_SYSTEMS.RELIGIONS },
  { code: 'none', display: 'No Religious Affiliation', system: CUSTOM_CODE_SYSTEMS.RELIGIONS },
  { code: 'other', display: 'Other', system: CUSTOM_CODE_SYSTEMS.RELIGIONS },
  { code: 'declined', display: 'Prefer Not to Answer', system: CUSTOM_CODE_SYSTEMS.RELIGIONS },
];

export const PROGRAMS: ReferenceDataItem[] = [
  { code: 'CCM', display: 'Chronic Care Management', system: CUSTOM_CODE_SYSTEMS.PROGRAMS },
  { code: 'RPM', display: 'Remote Patient Monitoring', system: CUSTOM_CODE_SYSTEMS.PROGRAMS },
  {
    code: 'RTM',
    display: 'Remote Therapeutic Monitoring',
    system: CUSTOM_CODE_SYSTEMS.PROGRAMS,
  },
  {
    code: 'BHI',
    display: 'Behavioral Health Integration',
    system: CUSTOM_CODE_SYSTEMS.PROGRAMS,
  },
];

export const ENTITY_TYPES: ReferenceDataItem[] = [
  { code: 'organization', display: 'Organization', system: CUSTOM_CODE_SYSTEMS.ENTITY_TYPES },
  { code: 'practice', display: 'Practice', system: CUSTOM_CODE_SYSTEMS.ENTITY_TYPES },
  { code: 'clinic', display: 'Clinic', system: CUSTOM_CODE_SYSTEMS.ENTITY_TYPES },
  { code: 'hospital', display: 'Hospital', system: CUSTOM_CODE_SYSTEMS.ENTITY_TYPES },
  { code: 'health-system', display: 'Health System', system: CUSTOM_CODE_SYSTEMS.ENTITY_TYPES },
  { code: 'medical-group', display: 'Medical Group', system: CUSTOM_CODE_SYSTEMS.ENTITY_TYPES },
];

export type VitalTypeItem = ReferenceDataItem & {
  defaultUnits: string;
  loincCode: string;
  hasSecondaryValue?: boolean;
};

export const VITAL_TYPES: VitalTypeItem[] = [
  {
    code: '85354-9',
    display: 'Blood Pressure',
    system: 'http://loinc.org',
    defaultUnits: 'mm[Hg]',
    loincCode: '85354-9',
    hasSecondaryValue: true,
  },
  {
    code: '8867-4',
    display: 'Heart Rate',
    system: 'http://loinc.org',
    defaultUnits: '/min',
    loincCode: '8867-4',
  },
  {
    code: '8310-5',
    display: 'Body Temperature',
    system: 'http://loinc.org',
    defaultUnits: '[degF]',
    loincCode: '8310-5',
  },
  {
    code: '2339-0',
    display: 'Blood Glucose',
    system: 'http://loinc.org',
    defaultUnits: 'mg/dL',
    loincCode: '2339-0',
  },
  {
    code: '9279-1',
    display: 'Respiratory Rate',
    system: 'http://loinc.org',
    defaultUnits: '/min',
    loincCode: '9279-1',
  },
  {
    code: '2708-6',
    display: 'Oxygen Saturation',
    system: 'http://loinc.org',
    defaultUnits: '%',
    loincCode: '2708-6',
  },
  {
    code: '29463-7',
    display: 'Body Weight',
    system: 'http://loinc.org',
    defaultUnits: 'kg',
    loincCode: '29463-7',
  },
  {
    code: '8302-2',
    display: 'Body Height',
    system: 'http://loinc.org',
    defaultUnits: 'cm',
    loincCode: '8302-2',
  },
];

export const VITAL_POSITIONS: ReferenceDataItem[] = [
  { code: 'sitting', display: 'Sitting', system: 'http://snomed.info/sct' },
  { code: 'standing', display: 'Standing', system: 'http://snomed.info/sct' },
  { code: 'lying', display: 'Lying Down', system: 'http://snomed.info/sct' },
  { code: 'reclining', display: 'Reclining', system: 'http://snomed.info/sct' },
];

export const VITAL_METHODS: ReferenceDataItem[] = [
  { code: 'manual', display: 'Manual', system: CUSTOM_CODE_SYSTEMS.VITAL_METHODS },
  { code: 'automatic', display: 'Automatic/Device', system: CUSTOM_CODE_SYSTEMS.VITAL_METHODS },
  {
    code: 'patient-reported',
    display: 'Patient Reported',
    system: CUSTOM_CODE_SYSTEMS.VITAL_METHODS,
  },
];

export const ALLERGY_REACTIONS: ReferenceDataItem[] = [
  { code: '39579001', display: 'Anaphylaxis', system: 'http://snomed.info/sct' },
  { code: '271807003', display: 'Rash', system: 'http://snomed.info/sct' },
  { code: '418290006', display: 'Itching', system: 'http://snomed.info/sct' },
  { code: '267036007', display: 'Difficulty Breathing', system: 'http://snomed.info/sct' },
  { code: '422587007', display: 'Nausea', system: 'http://snomed.info/sct' },
  { code: '422400008', display: 'Vomiting', system: 'http://snomed.info/sct' },
  { code: '62315008', display: 'Diarrhea', system: 'http://snomed.info/sct' },
  { code: '65124004', display: 'Swelling', system: 'http://snomed.info/sct' },
  { code: '25064002', display: 'Headache', system: 'http://snomed.info/sct' },
  { code: '404640003', display: 'Hives', system: 'http://snomed.info/sct' },
];

export const ALLERGY_SEVERITIES: ReferenceDataItem[] = [
  { code: 'mild', display: 'Mild', system: 'http://hl7.org/fhir/reaction-event-severity' },
  {
    code: 'moderate',
    display: 'Moderate',
    system: 'http://hl7.org/fhir/reaction-event-severity',
  },
  { code: 'severe', display: 'Severe', system: 'http://hl7.org/fhir/reaction-event-severity' },
];

export const CONSENT_TYPES: ReferenceDataItem[] = [
  { code: 'verbal', display: 'Verbal Consent', system: CUSTOM_CODE_SYSTEMS.CONSENT_TYPES },
  {
    code: 'written',
    display: 'Written Consent (Upload)',
    system: CUSTOM_CODE_SYSTEMS.CONSENT_TYPES,
  },
  {
    code: 'electronic',
    display: 'Electronic Consent',
    system: CUSTOM_CODE_SYSTEMS.CONSENT_TYPES,
  },
];

export const CONSENT_PARTIES: ReferenceDataItem[] = [
  { code: 'patient', display: 'Patient', system: CUSTOM_CODE_SYSTEMS.CONSENT_PARTIES },
  {
    code: 'proxy',
    display: 'Authorized Representative/Proxy',
    system: CUSTOM_CODE_SYSTEMS.CONSENT_PARTIES,
  },
];

export const CODE_STATUSES: ReferenceDataItem[] = [
  { code: 'active', display: 'Active', system: CUSTOM_CODE_SYSTEMS.CONDITION_STATUS },
  { code: 'resolved', display: 'Resolved', system: CUSTOM_CODE_SYSTEMS.CONDITION_STATUS },
  { code: 'inactive', display: 'Inactive', system: CUSTOM_CODE_SYSTEMS.CONDITION_STATUS },
  { code: 'recurrence', display: 'Recurrence', system: CUSTOM_CODE_SYSTEMS.CONDITION_STATUS },
];

export type TrackingCategoryItem = ReferenceDataItem & {
  description?: string;
};

export const TRACKING_CATEGORIES: TrackingCategoryItem[] = [
  {
    code: 'clinical-care',
    display: 'Clinical Care',
    description: 'Time spent on clinical activities',
    system: CUSTOM_CODE_SYSTEMS.TRACKING_CATEGORIES,
  },
  {
    code: 'administrative',
    display: 'Administrative',
    description: 'Time spent on administrative tasks',
    system: CUSTOM_CODE_SYSTEMS.TRACKING_CATEGORIES,
  },
  {
    code: 'documentation',
    display: 'Documentation',
    description: 'Time spent on documentation',
    system: CUSTOM_CODE_SYSTEMS.TRACKING_CATEGORIES,
  },
];

export type TrackingSubcategoryItem = ReferenceDataItem & {
  categoryCode: string;
  description?: string;
  uniqueName?: string;
};

export const TRACKING_SUBCATEGORIES: TrackingSubcategoryItem[] = [
  {
    code: 'patient-assessment',
    display: 'Patient Assessment',
    description: 'Initial patient assessment and evaluation',
    categoryCode: 'clinical-care',
    uniqueName: 'PATIENT_ASSESSMENT',
    system: CUSTOM_CODE_SYSTEMS.TRACKING_SUBCATEGORIES,
  },
  {
    code: 'care-coordination',
    display: 'Care Coordination',
    description: 'Coordinating care with other providers',
    categoryCode: 'clinical-care',
    uniqueName: 'CARE_COORDINATION',
    system: CUSTOM_CODE_SYSTEMS.TRACKING_SUBCATEGORIES,
  },
  {
    code: 'scheduling',
    display: 'Scheduling',
    description: 'Scheduling appointments and tasks',
    categoryCode: 'administrative',
    uniqueName: 'SCHEDULING',
    system: CUSTOM_CODE_SYSTEMS.TRACKING_SUBCATEGORIES,
  },
  {
    code: 'chart-review',
    display: 'Chart Review',
    description: 'Reviewing patient charts and documentation',
    categoryCode: 'documentation',
    uniqueName: 'CHART_REVIEW',
    system: CUSTOM_CODE_SYSTEMS.TRACKING_SUBCATEGORIES,
  },
];

export const RELATIONSHIPS: ReferenceDataItem[] = [
  { code: 'spouse', display: 'Spouse', system: CUSTOM_CODE_SYSTEMS.RELATIONSHIPS },
  { code: 'parent', display: 'Parent', system: CUSTOM_CODE_SYSTEMS.RELATIONSHIPS },
  { code: 'child', display: 'Child', system: CUSTOM_CODE_SYSTEMS.RELATIONSHIPS },
  { code: 'sibling', display: 'Sibling', system: CUSTOM_CODE_SYSTEMS.RELATIONSHIPS },
  { code: 'friend', display: 'Friend', system: CUSTOM_CODE_SYSTEMS.RELATIONSHIPS },
  { code: 'other', display: 'Other', system: CUSTOM_CODE_SYSTEMS.RELATIONSHIPS },
];
